export default {
  en: {
    yes: 'Yes',
    no: 'No',
    chart: {
      card: {
        more: 'More options for {title}',
        help: 'About {title}',
        downloadImage: 'Download as image',
        downloadImageFailed: "Couldn't download the image. Try again.",
      },
      types: {
        table: 'Table',
        number: 'Single number',
        bar: 'Bar chart',
        line: 'Line chart',
        pie: 'Pie chart',
      },
      // A query's rows, by entity, for the caption and the empty state. An
      // entity with no entry here uses the default.
      entities: {
        default: 'no rows | {n} row | {n} rows',
        answers: 'no answers | {n} answer | {n} answers',
        overrides: 'no overrides | {n} override | {n} overrides',
        reviews: 'no reviews | {n} review | {n} reviews',
        suppliers: 'no suppliers | {n} supplier | {n} suppliers',
      },
      noRowsTitles: {
        default: 'No rows match these filters',
        answers: 'No answers match these filters',
        overrides: 'No overrides match these filters',
        reviews: 'No reviews match these filters',
        suppliers: 'No suppliers match these filters',
      },
      caption: {
        grouped: '{groups} from {population}',
        ungrouped: 'From {population}',
        groups: 'no groups | {n} group | {n} groups',
      },
      capped: 'Showing {shown} of {total} groups',
      oneCategory: 'A chart with one group says little. Try grouping by something else.',
      noRowsSubtitle: 'Change the filters to see results.',
      allEmpty: {
        title: 'No values to show',
        subtitle:
          'Every value in these results is empty, for example because no supplier has shared an assessment.',
      },
      noLongerFits: 'This chart no longer fits the results. Showing the table instead.',
      failedToDraw: "Couldn't draw this chart. Showing the table instead.",
      unknownType: "This chart type isn't available",
      unreadable: "This chart's saved settings can't be read",
      other: 'Other',
      otherGroups: '{n} smaller group | {n} smaller groups',
      total: 'Total',
      noValue: 'No value',
      number: {
        empty: '–',
      },
      bar: {
        dropped: 'Showing the {shown} highest of {total} groups',
      },
      loading: 'Loading chart',
      measures: {
        count: 'Count',
        count_distinct: '{field} (distinct count)',
        sum: '{field} (total)',
        avg: '{field} (average)',
        median: '{field} (median)',
        min: '{field} (lowest)',
        max: '{field} (highest)',
        list: '{field} (list)',
      },
      quarter: 'Q{quarter} {year}',
      weekOf: 'Week of {date}',
      groupedBy: {
        default: 'Grouped by the {bucket} of {field}',
        buckets: {
          week: 'week',
          month: 'month',
          quarter: 'quarter',
          year: 'year',
        },
        fields: {
          connected_at: 'Grouped by the {bucket} each supplier connected',
          last_answer_at: "Grouped by the {bucket} of each supplier's last answer",
          last_completed_review_at:
            "Grouped by the {bucket} of each supplier's last completed review",
          reassessment_due_at: "Grouped by the {bucket} each supplier's reassessment is due",
        },
      },
      emptyGroup: {
        default: 'None',
        assigned_users: 'Unassigned',
        assessment_complete: 'Not shared',
        criticality: 'No criticality',
        labels: 'No labels',
        owner: 'No owner',
        owner_labels: 'No owner labels',
        sector: 'No sector',
      },
      reasons: {
        tooManyGroupings: 'Charts can show at most 2 groupings: this query has {count}',
        groupingNotSelected: 'Charts need every grouping as a column in the results',
        mixedMeasures: "Numbers and percentages can't share one axis",
        notStackable: 'Only counts and sums can be stacked',
        stackedMeasures: "Different measures can't be stacked on each other",
        tooManySeries: 'Too many series for a {chart}: {count}, maximum {max}',
        capped: "A {chart} can't show a result that is cut off at {shown} of {total} groups",
        cappedSeries:
          "A {chart} with series can't show a result that is cut off at {shown} of {total} groups, as missing pairs would look like 0",
        missingColumn: 'A column this chart uses is no longer in the results',
        numberShape: 'A single number needs one measure and no grouping',
        numberRows: 'A single number needs exactly 1 row: this result has {count}',
        barShape:
          'A bar chart needs 1 grouping and at least 1 measure, or 2 groupings and 1 measure',
        lineShape:
          'A line chart needs dates grouped by week, month, quarter or year, and at least 1 measure',
        lineBuckets: 'A line chart needs at least 2 dates: this result has {count}',
        pieShape: 'A pie chart needs 1 grouping and 1 count or sum',
        pieNotAdditive:
          "A pie chart needs a count or sum: averages and percentages can't be split into parts",
        pieNegative: "A pie chart can't show negative values",
        pieNoValues: 'A pie chart needs at least one value above 0',
        pieTooFew: 'A pie chart needs at least {min} categories: this result has {count}',
      },
      summary: {
        number: '{title}: {value}',
        noValues: '{chart} of {title}: no values',
        categories: '{chart} of {title}: {count}, highest {label} at {value}',
        series: '{chart} of {title}: {count} in {series}',
        categoryCount: 'no categories | {n} category | {n} categories',
        seriesCount: 'no series | {n} series | {n} series',
      },
    },
  },
};
